export const CODESIGNAL_PATH_ID = "journey-into-data-science-with-python";
const LEGACY_PLATFORM_FILTERS = new Set(["Sololearn", "CodeSignal"]);

export const CERTIFICATE_GROUPS = {
  [CODESIGNAL_PATH_ID]: {
    id: CODESIGNAL_PATH_ID,
    title: {
      fr: "Parcours Journey into Data Science with Python",
      en: "Journey into Data Science with Python learning path",
    },
    parentCertificateId: "codesignal-journey-into-data-science-with-python",
  },
};

export const CERTIFICATES = [
  {
    id: "codesignal-journey-into-data-science-with-python",
    issuer: "CodeSignal",
    category: "CodeSignal",
    type: "path-achievement",
    groupId: CODESIGNAL_PATH_ID,
    issuedAt: "2026-05-25",
    officialDate: "2026-05-25",
    dateLabel: { fr: "25 Mai 2026", en: "May 25, 2026" },
    officialTitle: "Journey into Data Science with Python",
    title: {
      fr: "Certificat d’achèvement — Parcours Journey into Data Science with Python",
      en: "Certificate of Achievement — Journey into Data Science with Python",
    },
    summary: {
      fr: "Document final de synthèse regroupant les certifications obtenues sur CodeSignal dans le cadre du parcours Journey into Data Science with Python.",
      en: "Final summary credential covering the CodeSignal certificates earned throughout the Journey into Data Science with Python learning path.",
    },
    file: "/certificates/journey-into-data-science-with-python.pdf",
    displayPriority: 100,
  },
  {
    id: "codesignal-introduction-to-supervised-machine-learning",
    issuer: "CodeSignal",
    category: "CodeSignal",
    type: "course",
    groupId: CODESIGNAL_PATH_ID,
    issuedAt: "2026-05-17",
    officialDate: "2026-05-17",
    dateLabel: { fr: "17 Mai 2026", en: "May 17, 2026" },
    officialTitle: "Introduction to Supervised Machine Learning",
    title: {
      fr: "Introduction à l’apprentissage supervisé",
      en: "Introduction to Supervised Machine Learning",
    },
    file: "/certificates/certificate-supervised-learning.pdf",
    displayPriority: 90,
  },
  {
    id: "codesignal-deep-dive-into-numpy-and-pandas-with-housing-data",
    issuer: "CodeSignal",
    category: "CodeSignal",
    type: "course",
    groupId: CODESIGNAL_PATH_ID,
    issuedAt: "2026-02-11",
    officialDate: "2026-02-11",
    dateLabel: { fr: "11 Février 2026", en: "February 11, 2026" },
    officialTitle: "Deep Dive into Numpy and Pandas with Housing Data",
    title: {
      fr: "Approfondissement de NumPy et Pandas avec des données immobilières",
      en: "Deep Dive into Numpy and Pandas with Housing Data",
    },
    file: "/certificates/data-visualization-deep-dive.pdf",
    displayPriority: 80,
  },
  {
    id: "codesignal-intro-to-data-cleaning-and-preprocessing-with-titanic",
    issuer: "CodeSignal",
    category: "CodeSignal",
    type: "course",
    groupId: CODESIGNAL_PATH_ID,
    issuedAt: "2026-02-01",
    officialDate: "2026-02-01",
    dateLabel: { fr: "1 Février 2026", en: "February 1, 2026" },
    officialTitle: "Intro to Data Cleaning and Preprocessing with Titanic",
    title: {
      fr: "Introduction au nettoyage et au prétraitement des données avec Titanic",
      en: "Intro to Data Cleaning and Preprocessing with Titanic",
    },
    file: "/certificates/data-cleaning-preprocessing.pdf",
    displayPriority: 80,
  },
  {
    id: "codesignal-intro-to-time-series-analysis-with-airline-data",
    issuer: "CodeSignal",
    category: "CodeSignal",
    type: "course",
    groupId: CODESIGNAL_PATH_ID,
    issuedAt: "2026-01-15",
    officialDate: "2026-01-15",
    dateLabel: { fr: "15 Janvier 2026", en: "January 15, 2026" },
    officialTitle: "Intro to Time Series Analysis with Airline Data",
    title: {
      fr: "Introduction à l’analyse de séries temporelles avec des données aériennes",
      en: "Intro to Time Series Analysis with Airline Data",
    },
    file: "/certificates/time-series.pdf",
    displayPriority: 80,
  },
  {
    id: "codesignal-intro-to-data-visualization-with-titanic",
    issuer: "CodeSignal",
    category: "CodeSignal",
    type: "course",
    groupId: CODESIGNAL_PATH_ID,
    issuedAt: "2025-07-29",
    officialDate: "2025-07-29",
    dateLabel: { fr: "29 Juillet 2025", en: "July 29, 2025" },
    officialTitle: "Intro to Data Visualization with Titanic",
    title: {
      fr: "Introduction à la visualisation de données avec Titanic",
      en: "Intro to Data Visualization with Titanic",
    },
    file: "/certificates/seaborn.pdf",
    displayPriority: 80,
  },
  {
    id: "codesignal-basics-of-numpy-and-pandas-with-titanic-dataset",
    issuer: "CodeSignal",
    category: "CodeSignal",
    type: "course",
    groupId: CODESIGNAL_PATH_ID,
    issuedAt: "2025-07-13",
    officialDate: "2025-07-13",
    dateLabel: { fr: "13 Juillet 2025", en: "July 13, 2025" },
    officialTitle: "Basics of Numpy and Pandas with Titanic Dataset",
    title: {
      fr: "Bases de NumPy et Pandas avec le jeu de données Titanic",
      en: "Basics of Numpy and Pandas with Titanic Dataset",
    },
    file: "/certificates/numpy-pandas.pdf",
    displayPriority: 80,
  },
  {
    id: "sololearn-visualize-your-data",
    issuer: "Sololearn",
    category: "Sololearn",
    type: "course",
    issuedAt: "2026-05-09",
    officialDate: "2026-05-09",
    dateLabel: { fr: "9 Mai 2026", en: "May 9, 2026" },
    officialTitle: "Visualize Your Data",
    title: {
      fr: "Visualisez vos données",
      en: "Visualize Your Data",
    },
    file: "/certificates/visualize-your-data.pdf",
    displayPriority: 60,
  },
  {
    id: "sololearn-sql-intermediate",
    issuer: "Sololearn",
    category: "Sololearn",
    type: "course",
    issuedAt: "2026-01-26",
    officialDate: "2026-01-26",
    dateLabel: { fr: "26 Janvier 2026", en: "January 26, 2026" },
    officialTitle: "SQL Intermediate",
    title: {
      fr: "SQL intermédiaire",
      en: "SQL Intermediate",
    },
    file: "/certificates/sql-intermediate.pdf",
    displayPriority: 60,
  },
  {
    id: "sololearn-javascript-intermediate",
    issuer: "Sololearn",
    category: "Sololearn",
    type: "course",
    issuedAt: "2025-04-23",
    officialDate: "2025-04-23",
    dateLabel: { fr: "23 Avril 2025", en: "April 23, 2025" },
    officialTitle: "JavaScript Intermediate",
    title: {
      fr: "JavaScript intermédiaire",
      en: "JavaScript Intermediate",
    },
    file: "/certificates/javascript-intermediate.png",
    displayPriority: 60,
  },
  {
    id: "sololearn-ai-powered-ab-testing",
    issuer: "Sololearn",
    category: "Sololearn",
    type: "course",
    issuedAt: "2025-04-09",
    officialDate: "2025-04-09",
    dateLabel: { fr: "9 Avril 2025", en: "April 9, 2025" },
    officialTitle: "AI-Powered A/B Testing",
    title: {
      fr: "A/B testing assisté par l’IA",
      en: "AI-Powered A/B Testing",
    },
    file: "/certificates/ab-testing.pdf",
    displayPriority: 60,
  },
  {
    id: "sololearn-python-intermediate",
    issuer: "Sololearn",
    category: "Sololearn",
    type: "course",
    issuedAt: "2023-08-06",
    officialDate: "2023-08-06",
    dateLabel: { fr: "6 Août 2023", en: "August 6, 2023" },
    officialTitle: "Python Intermediate",
    title: {
      fr: "Python intermédiaire",
      en: "Python Intermediate",
    },
    file: "/certificates/python-intermediate.pdf",
    displayPriority: 60,
  },
  {
    id: "emc-certificate-of-completion",
    issuer: "Emerging Malagasy Changemakers",
    category: "Other",
    type: "certificate",
    issuedAt: "2024-11-01",
    officialDate: "2024",
    dateLabel: { fr: "Novembre 2024", en: "November 2024" },
    officialTitle: "Certificate of Completion",
    title: {
      fr: "Certificat de fin de programme",
      en: "Certificate of Completion",
    },
    file: "/certificates/emc-2024.pdf",
    displayPriority: 40,
  },
  {
    id: "pole-stage-certificat-de-formation",
    issuer: "Pôle Stage Madagascar",
    category: "Other",
    type: "training-certificate",
    issuedAt: "2022-07-15",
    officialDate: "2022-07-15",
    dateLabel: { fr: "15 Juillet 2022", en: "July 15, 2022" },
    officialTitle: "CERTIFICAT DE FORMATION",
    title: {
      fr: "Certificat de formation pré-stage",
      en: "Training Certificate",
    },
    file: "/certificates/pole-stage.pdf",
    displayPriority: 40,
  },
  {
    id: "apeespa-attestation-de-formation-management-special-training-cohort-1",
    issuer: "APEESPA",
    category: "Other",
    type: "training-certificate",
    issuedAt: "2022-05-14",
    officialDate: "2022-05-14",
    dateLabel: { fr: "14 Mai 2022", en: "May 14, 2022" },
    officialTitle: "ATTESTATION DE FORMATION",
    title: {
      fr: "Attestation de formation en management spécial Training Cohort 1",
      en: "Training Attestation — Management Special Training Cohort 1",
    },
    file: "/certificates/management-cohort1.pdf",
    displayPriority: 40,
  },
];

const toLegacyCompatibleCertificate = (certificate) => ({
  ...certificate,
  etablissement: LEGACY_PLATFORM_FILTERS.has(certificate.category)
    ? certificate.category
    : certificate.issuer,
  nom: certificate.title?.fr || certificate.officialTitle || certificate.title?.en || certificate.id,
  dateObtention: certificate.dateLabel?.fr || certificate.officialDate || certificate.issuedAt,
  lien: certificate.file,
});

export const CERTIFICAT = [...CERTIFICATES]
  .sort(
    (a, b) =>
      b.displayPriority - a.displayPriority ||
      new Date(b.issuedAt).getTime() - new Date(a.issuedAt).getTime()
  )
  .map(toLegacyCompatibleCertificate);

const pickLocalized = (field, lang) =>
  (field && (field[lang] || field.fr)) || null;

/**
 * Vue localisée d'un certificat, destinée à l'affichage.
 *
 * Les champs de compatibilité (`nom`, `dateObtention`) restent figés en français
 * dans `CERTIFICAT` ; cette fonction les recalcule dans la langue courante avec
 * repli sur le français, et expose le résumé déjà résolu.
 *
 * @param {object} certificate - Entrée de `CERTIFICAT`
 * @param {string} lang - Langue courante ("fr" | "en")
 * @returns {object} Certificat prêt à l'affichage
 */
export const localizeCertificate = (certificate, lang) => ({
  ...certificate,
  nom:
    pickLocalized(certificate.title, lang) ||
    certificate.officialTitle ||
    certificate.id,
  dateObtention:
    pickLocalized(certificate.dateLabel, lang) ||
    certificate.officialDate ||
    certificate.issuedAt,
  summaryText: pickLocalized(certificate.summary, lang),
});
